<template>
  <div class="tabelas mt-3">
    <TabelaOsPedido v-if="frenteCaixa.tipoDeFiltro == 'OS'" />
    <TabelaRecebimentosAvulsos v-else-if="frenteCaixa.tipoDeFiltro == 'recebimentosAvulso'" />
    <TabelaPagamentosAvulsos v-else-if="frenteCaixa.tipoDeFiltro == 'pagamentosAvulso'" /> 
    <TabelaFiltroTodos v-else-if="frenteCaixa.tipoDeFiltro == 'todos'" />
  </div> 
</template>

<script>
  // Components
  import TabelaOsPedido from "./TabelaOsPedido/TabelaOsPedido"
  import TabelaPagamentosAvulsos from "./TabelaPagamentosAvulsos/TabelaPagamentosAvulsos"
  import TabelaFiltroTodos from "./TabelaFiltroTodos/TabelaFiltroTodos"
  import TabelaRecebimentosAvulsos from "./TabelaRecebimentosAvulsos/TabelaRecebimentosAvulsos"

  // vuex
  import { mapState } from 'vuex'

  export default {
    name: "Tabelas",
    components: {
      TabelaOsPedido,
      TabelaPagamentosAvulsos,
      TabelaFiltroTodos,
      TabelaRecebimentosAvulsos
    },
    computed: mapState(['frenteCaixa']),
    methods: {
      mostrarTipodeFiltro (texto) {
        if (!this.frenteCaixa.pedidos.length) {
          if (this.frenteCaixa.tipoDeFiltro  == texto) {
            return texto
          }
          if (!this.frenteCaixa.tipoDeFiltro ) {
            return 'todos'
          }
        }
        if (!this.frenteCaixa.tipoDeFiltro ) {
          return 'todos'
        }
        if (this.frenteCaixa.tipoDeFiltro  === texto) {
          return texto
        }
      }
    }
  }
</script>

<style scoped>
    .tabelas {
        width: 104%;
    }

</style>